module.exports = __webpack_public_path__ + "01_long_black.179ad5fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_long_black.png
// module id = oAsz
// module chunks = 0